import { useState } from "react";
import { useReveal } from "../hooks/useReveal";

const SERVICES = [
  "Individual Psychotherapy",
  "Anxiety & Depression Counselling",
  "Trauma & PTSD Recovery",
  "Couples & Relationship Therapy",
  "Child & Adolescent Psychology",
  "Psychometric Assessment",
  "Pranic Stress & Anxiety Relief",
  "Physical Pain Healing",
  "Emotional Trauma Clearing",
  "Chakra Balancing & Spiritual Growth",
];

const WA_NUMBER = "919928009559";

export default function Contact() {
  const ref = useReveal();
  const [form, setForm] = useState({ name: "", phone: "", service: "", message: "" });

  const update = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    const greeting = `Namaste Dr. Kalpana,`;
    const lines = [
      greeting,
      ``,
      `My name is ${form.name || "—"}.`,
      `Mobile: ${form.phone || "—"}`,
      `I am interested in: ${form.service || "—"}`,
      ``,
      form.message
        ? `A few words about my situation: ${form.message}`
        : `I would like to book a session at your earliest availability.`,
      ``,
      `Sent via your website.`,
    ];
    const body = encodeURIComponent(lines.join("\n"));
    window.open(`https://wa.me/${WA_NUMBER}?text=${body}`, "_blank");
  };

  return (
    <section id="contact" className="section contact" ref={ref} data-testid="contact-section">
      <div className="container">
        <div className="reveal reveal--up" style={{ maxWidth: 720 }}>
          <span className="eyebrow">Begin the Conversation</span>
          <h2 className="section-title">Book your session — or simply say hello.</h2>
          <span className="divider-leaf">In Person · Online</span>
          <p className="section-lead" style={{ marginTop: 24 }}>
            Your message will open WhatsApp with the details pre-filled. You can edit
            it before sending. I personally read every enquiry and respond within
            twenty-four hours.
          </p>
        </div>

        <div className="contact__grid">
          <form
            className="form reveal reveal--slide"
            onSubmit={submit}
            data-testid="contact-form"
          >
            <div className="field">
              <label htmlFor="name">Full Name</label>
              <input
                id="name"
                type="text"
                required
                value={form.name}
                onChange={update("name")}
                placeholder="How may I address you?"
                data-testid="form-name"
              />
            </div>

            <div className="field">
              <label htmlFor="phone">Mobile Number</label>
              <input
                id="phone"
                type="tel"
                required
                value={form.phone}
                onChange={update("phone")}
                placeholder="+91 ..."
                data-testid="form-phone"
              />
            </div>

            <div className="field">
              <label htmlFor="service">Service of Interest</label>
              <select
                id="service"
                required
                value={form.service}
                onChange={update("service")}
                data-testid="form-service"
              >
                <option value="">Choose a service…</option>
                {SERVICES.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </div>

            <div className="field">
              <label htmlFor="message">A Few Words (optional)</label>
              <textarea
                id="message"
                rows={4}
                value={form.message}
                onChange={update("message")}
                placeholder="What brings you here? Anything you'd like me to know in advance."
                data-testid="form-message"
              />
            </div>

            <button
              type="submit"
              className="btn btn--solid form__submit"
              data-testid="form-submit"
            >
              <i className="fa-brands fa-whatsapp"></i>
              Send via WhatsApp
            </button>
          </form>

          <aside className="info-stack reveal reveal--slide">
            <a
              href="mailto:randhawakalpana@gmail.com"
              className="info"
              data-testid="info-email"
            >
              <span className="info__icon"><i className="fa-regular fa-envelope"></i></span>
              <span>
                <span className="info__label">Email</span>
                <span className="info__value" style={{ display: "block" }}>
                  randhawakalpana@gmail.com
                </span>
              </span>
            </a>

            <a
              href="tel:+919928009559"
              className="info"
              data-testid="info-phone"
            >
              <span className="info__icon"><i className="fa-solid fa-phone"></i></span>
              <span>
                <span className="info__label">Phone & WhatsApp</span>
                <span className="info__value" style={{ display: "block" }}>
                  +91 9928 009 559
                </span>
              </span>
            </a>

            <div className="info" data-testid="info-address">
              <span className="info__icon"><i className="fa-solid fa-location-dot"></i></span>
              <span>
                <span className="info__label">Sanctuary</span>
                <span className="info__value" style={{ display: "block" }}>
                  H.No-324, Officers Campus Main,<br />
                  Sirsi Road, Khatipura, Jaipur
                </span>
              </span>
            </div>

            <div style={{ marginTop: 12 }}>
              <span
                className="info__label"
                style={{
                  fontFamily: "var(--font-sub)",
                  fontSize: 11,
                  letterSpacing: "0.3em",
                  textTransform: "uppercase",
                  color: "var(--np-primary)",
                  marginBottom: 12,
                  display: "block",
                }}
              >
                Connect
              </span>
              <div className="social">
                <a
                  href="https://www.linkedin.com/in/dr-kalpana-randhawa-2675295a/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  data-testid="social-linkedin"
                >
                  <i className="fa-brands fa-linkedin-in"></i>
                </a>
                <a
                  href="https://wa.me/919928009559"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  data-testid="social-whatsapp"
                >
                  <i className="fa-brands fa-whatsapp"></i>
                </a>
                <a
                  href="mailto:randhawakalpana@gmail.com"
                  aria-label="Email"
                  data-testid="social-email"
                >
                  <i className="fa-regular fa-envelope"></i>
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
